module.exports = __webpack_public_path__ + "static/img/feature-icon4@3x.ed58ce32.png";